import { useState } from 'react';

import iconImg from '../../assets/images/icon.webp';

import Icon from '../icon/Icon';

import styles from '../../styles/modules/layout/App.module.scss';

import { usePromoStore } from '../../store/userPromoStore';
import { useConfigStore } from '../../store/useConfigStore';

import Modal from '../modal/Modal';

const Main = () => {
	const [copied, setCopied] = useState(false);

	const promo = usePromoStore((s) => s.promo);

	const { openModal } = useConfigStore((s) => s);

	const openModalHandler = () => {
		openModal(Modal);
	};

	const promocode = promo?.p || 'SECRET';

	const copyPromocode = async () => {
		try {
			await navigator.clipboard.writeText(promocode);

			setCopied(true);

			setTimeout(() => {
				openModalHandler();

				setCopied(false);
			}, 1500);
		} catch (e) {
			console.error('Copy failed');
		}
	};

	return (
		<div className={styles.inner}>
			<div className={styles.image}>
				<img src={iconImg} alt='' />
			</div>

			<div>
				{promo?.s && <p className={styles.title}>{promo.s}</p>}
				<p className={styles.subtitle}>
					Получи <span>+{promo?.pt || 15}%</span> по промокоду!
				</p>
			</div>

			<div className={styles.actions}>
				<button type='button' onClick={openModalHandler}>
					<Icon name='steam1' />
					<span>зарегистрироваться</span>
				</button>

				<div className={styles.promocode} onClick={copyPromocode}>
					<p>{promocode}</p>

					<Icon name='copy' />

					{copied && <span className={styles.tooltip}>Скопировано!</span>}
				</div>
			</div>
		</div>
	);
};

export default Main;
